import React from "react"
import { useFormSubmissionReportExportContext } from "contexts/FormSubmissionReportExportContext"
import { DATE_TYPE } from "views/Forms/FormElementTypes"
import { DateInput } from "shared/inputs"
import { QuestionHistoryQuestionSelect } from "shared/selects"

const NewFormSubmissionReportExportFormDateAnswerFilters = () => {
  const {
    dateAnswerFilters,
    questions,
    setDateAnswerFilterEarliestDate,
    setDateAnswerFilterLatestDate,
    setDateAnswerFilterQuestionUuid,
  } = useFormSubmissionReportExportContext()

  const dateQuestions = questions.filter((question) => question.type === DATE_TYPE)

  if (dateQuestions.length === 0) {
    return (
      <p>There are no date questions on the form associated with this report.</p>
    )
  }

  const dateAnswerFilter = dateAnswerFilters[0] ?? {}
  const { earliestDate, latestDate, questionUuid } = dateAnswerFilter

  return (
    <div className="w-full">
      <QuestionHistoryQuestionSelect
        className="!w-full bordered-base-input mb-4"
        clearable
        onChange={setDateAnswerFilterQuestionUuid}
        questions={dateQuestions}
        selectLabel="select a date question to filter by"
        value={questionUuid}
      />
      {
        questionUuid && (
          <>
            <label aria-label="earliest answer date (mm/dd/yyyy)">
              <span aria-hidden>Earliest Date:</span>
              <DateInput
                className="mb-4"
                clearable
                onChange={setDateAnswerFilterEarliestDate}
                value={earliestDate}
              />
            </label>
            <label aria-label="latest answer date (mm/dd/yyyy)">
              <span aria-hidden>Latest Date:</span>
              <DateInput
                className="mb-4"
                clearable
                onChange={setDateAnswerFilterLatestDate}
                value={latestDate}
              />
            </label>
          </>
        )
      }
    </div>
  )
}

export default NewFormSubmissionReportExportFormDateAnswerFilters
